import { render } from "./QuotationList.vue?vue&type=template&id=02d0aa04&ts=true"
import script from "./QuotationList.vue?vue&type=script&lang=ts"
export * from "./QuotationList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__